import { EnvironmentProviders, isDevMode, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState, provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';

import { AuthEffects } from './auth/auth.effects';
import { authFeature } from './auth/auth.feature';
import { ProfileEffects } from './profile/profile.effects';
import { profileFeature } from './profile/profile.feature';

export function provideAppStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideStore(),
    provideState(authFeature),
    provideState(profileFeature),
    provideEffects([AuthEffects, ProfileEffects]),
    ...(isDevMode()
      ? [
          provideStoreDevtools({
            maxAge: 25,
            logOnly: false,
            connectInZone: false,
          }),
        ]
      : []),
  ]);
}
